import React from 'react';
import type { FormItemConfig } from '@ms/shared-components/comps/CompsForm';
import type { ThinkingMode } from '../../../services/aiConfigService';
import TagInput from '../../../components/TagInput';

const categoryOptions = [
  { label: '分析', value: 'analysis' },
  { label: '预测', value: 'prediction' },
  { label: '优化', value: 'optimization' },
];

export const getFormItems = (editingRecord?: ThinkingMode | null): FormItemConfig[] => [
  {
    name: 'id',
    label: '思考方式ID',
    type: 'input',
    rules: [{ required: true, message: '请输入思考方式ID' }],
    props: { disabled: !!editingRecord },
  },
  {
    name: 'label',
    label: '显示标签',
    type: 'input',
    rules: [{ required: true, message: '请输入显示标签' }],
  },
  {
    name: 'description',
    label: '描述',
    type: 'textarea',
    props: { rows: 4 },
  },
  {
    name: 'category',
    label: '分类',
    type: 'select',
    options: categoryOptions,
  },
  {
    name: 'positiveWords',
    label: '正面词',
    type: 'custom',
    customComponent: TagInput,
    props: { placeholder: '输入正面词，按回车添加，例如：总结、概述、要点' },
  },
  {
    name: 'negativeWords',
    label: '负面词',
    type: 'custom',
    customComponent: TagInput,
    props: { placeholder: '输入负面词，按回车添加，例如：猜测、假设、可能' },
  },
  {
    name: 'isActive',
    label: '是否启用',
    type: 'switch',
    valuePropName: 'checked',
    props: { checkedChildren: '启用', unCheckedChildren: '禁用' },
  },
];

export const formConfig = {
  layout: 'horizontal' as const,
  contentPadding: 0,
};
